import { DerivedValues, useScatterplotContext } from 'features/timeSeries'
import React from 'react'
import styled from 'styled-components'

const ContentContainer = styled.div`
  padding: 0.5rem;
  overflow-y: auto;
  width: 100%;
  position: relative;
`

const MessageContainer = styled.div`
  padding: 0.25rem 0.5rem;
  background-color: ${({ theme }) =>
    `color-mix(in srgb, ${theme.forecast.warning} 25%, transparent 75%)`};
  border-radius: 0.25rem;
  margin-bottom: 0.5rem;
`

const MessageTitle = styled.h3`
  color: ${({ theme }) => theme.forecast.defaultText};
  font-size: 1rem;
  font-weight: 600;
`

const MessageText = styled.p`
  color: ${({ theme }) => theme.forecast.text2};
  font-size: 0.875rem;
`

export const DerivedValuesTab: React.FC = () => {
  const { selectedSensors, sensorEntries } = useScatterplotContext()

  const hasSelectedSensors = selectedSensors.length > 0

  return (
    <ContentContainer>
      {!hasSelectedSensors && (
        <MessageContainer>
          <MessageTitle>No Tags Selected</MessageTitle>
          <MessageText>
            Please go to the Data from Tags tab and select some tags before
            creating calculations.
          </MessageText>
        </MessageContainer>
      )}
      <DerivedValues
        sensorEntries={sensorEntries}
        style={{
          opacity: !hasSelectedSensors ? 0.5 : 1,
          pointerEvents: !hasSelectedSensors ? 'none' : 'auto',
        }}
      />
    </ContentContainer>
  )
}
